/* 🤖 this file was generated by svg-to-ts */
export const DfIconTask16: {
  name: 'task-16';
  data: string;
} = {
  name: 'task-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M10 3.004A1.81 1.81 0 0 1 11.5 4l.138.276a.5.5 0 0 1-.447.724H4.809a.5.5 0 0 1-.447-.724L4.5 4A1.81 1.81 0 0 1 6 3.004V2a2 2 0 1 1 4 0v1.004zM5 1v1a1 1 0 0 1-1 1h-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5H12a1 1 0 0 1-1-1V1h2a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2zm3 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-.226 8.28a.74.74 0 0 1-1.108-.061l-1.45-1.452a.739.739 0 1 1 1.047-1.045l.988.989 2.487-2.495a.74.74 0 0 1 1.045 1.045l-2.997 3.007a.754.754 0 0 1-.012.012z"/></svg>`
};
